import { useTranslation } from "react-i18next";

type Props = {
  vehicle: {
    plateNumber: string;
    mileage: number;
    condition: number;
  };
};

export default function OfferVehicleInfo({ vehicle }: Props) {
  const { plateNumber, mileage, condition } = vehicle;
  const { t } = useTranslation("offer");
  return (
    <div className="flex gap-1.5 my-2.5">
      <div className="flex flex-col justify-center basis-[33.33333%] gap-0.5 h-14 px-3.5 text-14 font-bold bg-dark-800/50 border border-dashed border-[#1A1A1A] rounded-xl">
        {plateNumber}
        <span className="text-11 font-medium uppercase text-gray/50">
          {t("offer.vehicle.number")}
        </span>
      </div>
      <div className="flex flex-col justify-center basis-[33.33333%] gap-0.5 h-14 px-3.5 text-14 font-bold bg-dark-800/50 border border-dashed border-[#1A1A1A] rounded-xl">
        <div>
          {mileage}
          <span className="text-10 uppercase">km</span>
        </div>
        <span className="text-11 font-medium uppercase text-gray/50">
          {t("offer.vehicle.mileage")}
        </span>
      </div>
      <div className="flex flex-col justify-center basis-[33.33333%] gap-0.5 h-14 px-3.5 text-14 font-bold bg-dark-800/50 border border-dashed border-[#1A1A1A] rounded-xl">
        {condition}%
        <span className="text-11 font-medium uppercase text-gray/50">
          {t("offer.vehicle.status")}
        </span>
      </div>
    </div>
  );
}
